// extracted by mini-css-extract-plugin
module.exports = {"slide":"start-page_slide__3dpXe","active":"start-page_active__33OZd","mainLabel":"start-page_mainLabel__2DM8g","descr":"start-page_descr__1ak1R"};